import React from 'react';

import _ from 'lodash'


import OPieMapDyna from './OPieMapDyna'
import { SV_DEF as SVTipView } from './SVDef'
import Highcharts from 'highcharts'
import Exporting from 'highcharts/modules/exporting'

const FEATURE  = "FEATURE"
const TRACK = "TRACK"
const SELECTED = 'selected'
const NOT_SELECTED = ''



Exporting(Highcharts)
class OPieBody extends React.Component{
    constructor(props){
        super(props)
        let me = this
        this.svchartApiElToday4 = {
            svid :'id48'
        }
        this.onFilterChange = this.onFilterChange.bind(me)
        this.updateTimeFilters = this.updateTimeFilters.bind(me)

        this.state = {
            selectedTrack:SELECTED,
            selectedFeature:NOT_SELECTED,
            filters:{
                HOST_MATCH_CATEGORY:{
                    label:'Compliance Status',
                    options:['Complinat', 'NotCompliant', 'PhaseOut'],
                    id:'HOST_MATCH_CATEGORY',
                    values:[]
                }
            },
            filteredData:  [
            ]
        }
        this.svitin = {
            svStartDateTitle: 'Sep 7,2017',
            svEndDateTitle: 'Sep 8,2017',
            startLong: 1506321211089,
            endLong: 1505804560682,
            svStartDate: '09/07/2017',
            svpInterval: 15,
            svpUnit: 'min',
            svEnv: SVTipView.SVMICROSERVICES.SVENV_DEFAULT,
            svpointer: 0,
            svEndDate: '09/08/2017',
            svBiName: 'HNTT',
            svVoyageName: 'gix-dev',
            svShipName: 'RegalPrincess'

        };
        this.svchartConElToday = {
            svid: 'svceosr',
            layout: 6,
            svvis: 'line',
            svHeading: 'Carriers Availability In Cities ',
            svEventsShow: false,
            svFooter: 'Sea',
            svstartMeasure: 'doc_count',
            svstartBiReportType: 'SVBITYPE_SVCLOG',
            yName: 'doc_count'

        };
        this.svmetadataConElToday = {
            //analytic now
            // svendpoint:'svSvclogIntelligenceAllTrident_svanalytic',
            //svendpoint:'elkOsrChart',
            svendpoint: 'svelkAwsErrors',
            svrest: 'REST',
            svelkQueryType: 'USER',
            svServer: 'http://localhost:3004',
            //svServer: 'http://localhost:3004/',
            svMethod: "POST",
            svQueryGet: '',
            //  svendpoint:'svSvclogIntelligenceAllTrident_sv',
            //svendpoint:'svSvclogIntelligenceAllLocal_sv',
            svTodayDate: '2017-07-19',
            svHeading: 'Airlines US ',
            SVHNTT_DAILY: true,
            svEndPointClientFilterType: 'SVHNTT_DAILY'



        };
    }
    onFilterChange(){
        console.log('sv filter change...')
    }

    updateTimeFilters(id,ar){
        console.log('filter change id' +id)
        let allFilters = Object.assign({}, this.state.filters), matchFilter
        allFilters[id].values = ar
        matchFilter = allFilters[id]
        let dataAr = Object.assign({}, this.state.filteredData)
        const filteredData =  this.props.data.filter((row, k)=>{
           if(matchFilter.values.length ===0){
               return true
           }
           if(matchFilter.values.includes(row['DB_SYMMETRY'])){
              return true
           }
           return false

        })
        this.setState({filters:allFilters, filteredData:filteredData})
    }

    dataFromParent = () => {
        let data = [[0, 0, 1], [0, 1, 0.7], [0, 2, 0.3],
        [1, 0, 0.7], [1, 1, 1], [1, 2, 0.8],
        [2, 0, 0.5], [2, 1, 0.5], [2, 2, 1]];
        return data;
    }

    render(){
        let me = this
        const {selectedTrack, selectedFeature} = this.state
        let displayTrack =  (selectedTrack == SELECTED) ? 'block':'none'
        let displayFeature =  (selectedFeature == SELECTED) ? 'block':'none'
        console.log('graphBody gets svdata')
        console.log(this.props.data)
        return(

            <div classname="board-body-wrapper" >
           
            {/*  
                     <OPieMap data={this.dataFromParent()}></OPieMap>
                    
      
                    */}
          <OPieMapDyna id="svceosr" svchart={me.svchartConElToday} svmetadata={me.svmetadataConElToday} svitin={me.svitin}> </OPieMapDyna>
                {/*  
                <SlcpSectionMap data={this.dataFromParent()}></SlcpSectionMap>
                */}
                     
            </div>
        )


    }


}

export default OPieBody